var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border rounded-lg flex flex-col",class:[_vm.overflow, _vm.bgColor]},[_c('div',{class:{ 'divide-y': _vm.showSeparator }},[(_vm.$slots.header)?_c('div',[_vm._t("header")],2):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('div',{class:[_vm.contentWrapperClass]},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }